"use strict";
jQuery.fn.inlineStyle = function (prop) {
    return this.prop("style")[jQuery.camelCase(prop)];
};